// import { useParams } from 'react-router-dom';
// import { Container } from '@mui/material';
// import { useSelector } from 'react-redux';
// import { RootState } from '../../redux/storage/store';
// import Loader from '../../Component/Loader';
// // import Base64Image from '../../atoms/Base64Image';
// import DOMPurify from 'dompurify';
// import './careerDetail.scss';
// import { useEffect, useState } from 'react';

// interface CareerItem {
//   id: string;
//   jobTitle: string;
//   jobDescription: string;
//   experienceLevel: string;
//   jobType: string;
//   thumbnailImage?: string;
//   blogsImagesFirst?: string;
//   blogsImagesSecond?: string;
// }

// export default function CareerDetail(){
//   const { id } = useParams<{ id: string }>();
//   const { careers } = useSelector((state: RootState) => state.config);
//   const [careerItem, setCareerItem] = useState<any>(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState<string | null>(null);

//   useEffect(() => {
//     if (careers.length === 0) {
//       setError('No careers found.');
//       setLoading(false);
//       return;
//     }

//     const item = careers.find((career: any) => career.id === id);
//     if (item) {
//         console.log(item,"item");
//       setCareerItem(item);
//       setError(null);
//     } else {
//       setError('Career not found.');
//     }

//     setLoading(false);
//   }, [careers, id]);

//   if (loading) {
//     return <Loader />;
//   }

//   if (error) {
//     return (
//       <Container>
//         <div className="error-message">{error}</div>
//       </Container>
//     );
//   }

//   if (!careerItem) {
//     return (
//       <Container>
//         <p>Career item not found.</p>
//       </Container>
//     );
//   }

//   const sanitizedDescription = DOMPurify.sanitize(careerItem.jobDescription || '');

//   return (
//     <div className="media-details">
//       <Container>
//         {/* Breadcrumbs */}
//         <div className="MuiBreadcrumbs-root">
//           {/* Add your breadcrumbs here */}
//         </div>

//         {/* Career Item Header */}
//         <h1>{careerItem.jobTitle}</h1>
//         <h2>{careerItem.experienceLevel}</h2>
//         <h3>{careerItem.jobType}</h3>

//         {/* Career Item Thumbnail */}
//         {careerItem.thumbnailImage && (
//           <img className="banner" src={careerItem.thumbnailImage} alt={careerItem.jobTitle} />
//         )}

//         {/* Job Description */}
//         <div className="career-detail-content">
//           <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
//         </div>

//         {/* Additional Images */}
//         {/* <div>
//           {careerItem.blogsImagesFirst && (
//             <Base64Image src={careerItem.blogsImagesFirst} alt={careerItem.jobTitle} />
//           )}
//           {careerItem.blogsImagesSecond && (
//             <Base64Image src={careerItem.blogsImagesSecond} alt={careerItem.jobTitle} />
//           )}
//         </div>
//          */}
//         {/* More Insights Section */}
//         <div className="more-insights">
//           <div className="wave-pattern"></div>
//           <h4>More Insights</h4>
//         </div>
//       </Container>
//     </div>
//   );
// };

import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux/storage/store';
import Loader from '../../Component/Loader';
import AtomButton from '../../atoms/button'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import DOMPurify from 'dompurify';
import styles from './career.module.css';
import { useEffect, useState } from 'react';
import CareerFooter from './CareerFooter';
import { Link } from 'react-router-dom';
import { CareerFormData, getCareerById } from '../../services/careerService';
import { get } from 'http';
import emailjs from "@emailjs/browser"
import { uploadImageToFirebase } from '../../libs/utils';
import { toast } from 'react-toastify';
interface CareerItem {
    id: string;
    jobTitle: string;
    experienceLevel: string;
    maxExperienceLevel: string;
    jobType: string;
    education: string;
    noticePeriod: string;
    jobLocation: string;
    industry: string;
    salary: string;
    generalDescription: string;
    jobDescription: string;
    benefits: any;
    extraFields: any;
}

export default function CareerDetail() {
    const { id } = useParams<{ id: string }>();
    const { careers } = useSelector((state: RootState) => state.config);
    const [careerItem, setCareerItem] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);


    const handleResumeUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    console.log("Selected Resume File:", file);

    try {
      const downloadUrl = await uploadImageToFirebase(file, "resumes");

      const formData = {
        // to_email: "receiver@example.com", 
        file_url: downloadUrl,
        message: "New resume uploaded.",
      };

      await emailjs.send(
        "service_2es1ion",     
        "template_yei610l",     
        formData,
        "IAqrA2xNX9TehNX7h"       
      );

      console.log("Email sent successfully with resume URL.");
      toast.success("Resume uploaded successfully!");
    } catch (err) {
      console.error("Error uploading or sending email:", err);
    }
  };

    useEffect(() => {
        async function getCareer() {
            // if (careers.length === 0) {
            //     setError('No careers found.');
            //     setLoading(false);
            //     return;
            // }
             
            let item = careers?.find((career: CareerItem) => career.id === id);
            if (!item) {
                item = await getCareerByIdFromFirebase();
            }
            if (item) {
                setCareerItem(item);
                setError(null);
            } else {
                setError('Career not found.');
            }

            setLoading(false);
        }
        getCareer();
    }, [careers, id]);

    async function getCareerByIdFromFirebase(): Promise<CareerFormData | null> {
        if (!id) {
            setError('Career ID is required.');
            return null;
        }
        return await getCareerById(id);
    }

    if (loading) return <Loader />;
    if (error) return <Container><div className={styles.error}>{error}</div></Container>;
    if (!careerItem) return <Container><p>Career item not found.</p></Container>;

    const sanitizedDescription = DOMPurify.sanitize(careerItem.generalDescription || '');
    const excludeKeys = ['id', 'jobTitle', 'experienceLevel', 'generalDescription', 'jobDescription', 'benefits', 'extraFields'];

    return (
        <div className={styles.page}>
            <Container>
                <Breadcrumbs aria-label="breadcrumb">
                    <Link to="/careers">
                        <AtomButton>
                            Careers
                        </AtomButton>
                    </Link>
                    <span>{careerItem.jobTitle}</span>
                </Breadcrumbs>
                <div className={styles.header}>
                    <div className={styles.headerTop}>
                        <h1 className={styles.jobTitle}>{careerItem.jobTitle}</h1>
                        <label className={styles.uploadButton}>
                            Upload Resume
                            <input
                                type="file"
                                accept=".pdf,.doc,.docx"
                                onChange={handleResumeUpload}
                                hidden
                            />
                        </label>
                    </div>

                    <h2 className={styles.highlight}>{careerItem.experienceLevel} - {careerItem?.maxExperienceLevel || 'Max'} Years</h2>
                    <p className={styles.summary}>
                        {careerItem.jobDescription}
                    </p>
                </div>

                <div className={styles.detailsTable}>
                    {/* Render all non-excluded keys */}
                    {Object.keys(careerItem)
                        .filter(key => !excludeKeys.includes(key) && key !== "extraFields")
                        .map((key) => (
                            <div className={styles.detailRow} key={key}>
                                <span className={styles.label}>{key.replace(/([A-Z])/g, ' $1').toUpperCase()}</span>
                                <span className={styles.value}>{careerItem[key]}</span>
                            </div>
                        ))}

                    {/* Render dynamic extraFields */}
                    {Array.isArray(careerItem.extraFields) &&
                        careerItem.extraFields.map((field: any, index: number) => (
                            <div className={styles.detailRow} key={`extra-${index}`}>
                                <span className={styles.label}>{field.key.toUpperCase()}</span>
                                <span className={styles.value}>{field.value}</span>
                            </div>
                        ))}
                </div>

                <div className={styles.description}>
                    <h3>General Description:</h3>
                    <div dangerouslySetInnerHTML={{ __html: sanitizedDescription }}></div>
                </div>
                <div className={styles.benefitsSection}>
                    <h3>Benefits:</h3>
                    <div className={styles.benefitsGrid}>
                        {careerItem?.benefits?.map((benefit: any) => (
                            <div key={benefit.key} className={styles.benefitItem}>
                                <img src={benefit.image} alt={benefit.title} />
                                <p>{benefit.key}</p>
                            </div>
                        ))}
                    </div>
                </div>



            </Container>
            <CareerFooter />
        </div>
    );
}
